import { listCollection } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import { track } from "../lib/analytics.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import VideoEmbed from "../components/VideoEmbed/VideoEmbed.jsx";
import CTABand from "../components/CTABand/CTABand.jsx";
import styles from "./webinars.module.css";

const PAGE = {
  title: "Webinars",
  description:
    "RDV Systems webinars on Road Safety Audit 3D for existing roads and new designs, with downloadable case studies.",
  path: "/resources/webinars",
};

export function meta() {
  return buildMeta(PAGE);
}

export async function loader() {
  return { items: listCollection("webinars") };
}

export default function Webinars({ loaderData }) {
  return (
    <>
      <PageHero
        eyebrow="Webinars"
        title="Recorded sessions and materials"
        lead={PAGE.description}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Resources", path: "/resources" },
          { name: "Webinars", path: PAGE.path },
        ]}
      />
      <section className="section">
        <div className={`container ${styles.list}`}>
          {loaderData.items.map((w) => (
            <article key={w.slug}>
              <p className="eyebrow">{[w.date, w.presenter].filter(Boolean).join(" · ")}</p>
              <h2>{w.title}</h2>
              <p className="lead">{w.description}</p>
              {w.video ? <VideoEmbed video={w.video} title={w.title} /> : null}
              {w.pdf ? (
                <p style={{ marginTop: "var(--sp-4)" }}>
                  <a
                    className="btn btn-secondary"
                    href={w.pdf}
                    download
                    onClick={() => track("pdf_download", { file: w.pdf })}
                  >
                    Download the case study (PDF)
                  </a>
                </p>
              ) : null}
            </article>
          ))}
        </div>
      </section>
      <CTABand
        title="Want a private session for your team?"
        text="We run webinars for DOT districts and firms on request."
        to="/contact?interest=webinar"
        label="Request a private webinar"
      />
    </>
  );
}
